export enum AuthActionTypes {
  CHECK_USER = "@@AUTH/CHECK_USER",
  CHECK_USER_SUCCESS = "@@AUTH/CHECK_USER_SUCCESS",
  CHECK_USER_FAILURE = "@@AUTH/CHECK_USER_SUCCESS",

  VERIFY_USER = "@@AUTH/VERIFY_USER",
  VERIFY_USER_SUCCESS = "@@AUTH/VERIFY_USER_SUCCESS",
  VERIFY_USER_FAILURE = "@@AUTH/VERIFY_USER_FAILURE",

  LOGIN = "@@AUTH/LOGIN",
  LOGIN_SUCCESS = "@@AUTH/LOGIN_SUCCESS",
  LOGIN_FAILURE = "@@AUTH/LOGIN_FAILURE",

  LOGOUT = "@@AUTH/LOGOUT",
  LOGOUT_SUCCESS = "@@AUTH/LOGOUT_SUCCESS",
  LOGOUT_FAILURE = "@@AUTH/LOGOUT_FAILURE",

  REGISTRATION = "@@AUTH/REGISTRATION",
  REGISTRATION_SUCCESS = "@@AUTH/REGISTRATION_SUCCESS",
  REGISTRATION_FAILURE = "@@AUTH/REGISTRATION_FAILURE",

  SET_PASSWORD = "@@AUTH/SET_PASSWORD",
  SET_PASSWORD_SUCCESS = "@@AUTH/SET_PASSWORD_SUCCESS",
  SET_PASSWORD_FAILURE = "@@AUTH/SET_PASSWORD_FAILURE",

  FORGOT_PASSWORD = "@@AUTH/FORGOT_PASSWORD",
  FORGOT_PASSWORD_SUCCESS = "@@AUTH/FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE = "@@AUTH/FORGOT_PASSWORD_FAILURE",
}
